import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import './player.css';
import { Row, Col } from 'react-bootstrap';

import UserHeader from '../UserHeader';
import { formatDate } from '../utils/utils';
import { highlightColumnColor, checkHealthScoreStatus, showHealthyToReturnDate, calculateHeight, getMappedBodyPart, getMappedBodyPartFromPlayer, isPlayerFullyRecovered } from '../utils/dashboardCalculations';
import { Line } from 'rc-progress';
import DashboardTip from './../Tooltip/dashboardTip';
import currentStatus from '../../global/img/1.png'
import expectedReturn from '../../global/img/2.png'
import fullRecovery from '../../global/img/3.png'
import gameMissed from '../../global/img/4.png'
import footballIcon from '../../global/img/football.svg'
import basketballIcon from '../../global/img/basketball.svg'
import soccerIcon from '../../global/img/soccer.svg'
import FiboMeter from '../FiboMeter';
import booster from '../../global/img/booster.svg'
import boosterarrow from '../../global/img/booster-arrow.svg'
import doctorsedge from '../../global/img/carousel/doctorsedge.png'
import profile from '../../global/img/profile.png'
import PlayerNews from './News/PlayerNews';
import AggregatedNews from './News/AggregatedNews';
import TwitterFeed from './News/TwitterFeed';
import LatestNews from './News/LatestNews';
import FiboMeterLegend from './FiboMeterLegend';
import FiboMeterPanel from './FiboMeterPanel';

const mapStatusToActive = (status) => {
	const inactiveStatuses = [
		'Doubtful',
		'Out',
		'Did Not Practice',
		'Suspended',
		'Physically Unable to Perform',
		'Injured Reserve',
		'IR',
		'NFI'
	];
	console.log(status,'status')

	// Convert status to lowercase for case-insensitive comparison
	const normalizedStatus = status ? status.toLowerCase().trim() : '';
	
	return inactiveStatuses.includes(normalizedStatus) ? 'Inactive' : 'Active';
};

// Function to analyze all statuses from grid_status and determine overall status
const getStatusFromGridStatus = (gridStatus) => {
	console.log(gridStatus,'gridStatus')
	if (!gridStatus || typeof gridStatus !== 'string') {
		return null;
	}

	// Parse the grid_status string (e.g., "DNP:1,DNP:2,DNP:3,INACTIVE:2,INACTIVE:3,QUESTIONABLE:1,LP:0.5")
	const statusItems = gridStatus.split(',').map(item => item.trim());
	console.log(statusItems, 'statusItems')
	
	if (statusItems.length === 0) {
		return null;
	}

	// Extract all unique statuses
	const allStatuses = statusItems.map(item => {
		const [status] = item.split(':');
		return status ? status.trim().toLowerCase() : null;
	}).filter(Boolean);

	console.log(allStatuses, 'allStatuses')

	// Define inactive status patterns
	const inactiveStatuses = [
		'doubtful', 'out', 'did not practice', 'dnp', 'suspended',
		'physically unable to perform', 'injured reserve', 'ir', 'nfi',
		'inactive', 'questionable', 'lp', 'limited practice'
	];

	// Check if any status indicates the player is inactive
	const hasInactiveStatus = allStatuses.some(status => 
		inactiveStatuses.includes(status)
	);

	// If any inactive status is found, player is considered inactive
	// Otherwise, they're active
	return hasInactiveStatus ? 'Inactive' : 'Active';
};

function Player(props) {
	const { dispatch, player, user, togglePlayerView, cfbPlayerNews, cfbTeamNews } = props;
	let { playerID } = props;
	const sportFromUrlInit = window.location.pathname.split('/')[1]?.toLowerCase();
	const isCFBInit = sportFromUrlInit === 'cfb';
	useEffect(() => {
		window.scrollTo(0, 0);
		const url = window.location.pathname.split('/');
		// eslint-disable-next-line react-hooks/exhaustive-deps
		playerID = playerID || url[url.length - 1];
		dispatch({
			type: 'GET_PLAYER',
			payload: { playerID }
		});
		if (isCFBInit) {
			dispatch({ type: 'GET_CFB_PLAYER_NEWS', payload: { playerID } });
		}
	}, []);

	const title = 'Health Scores for Player';
	// const redirectURL = `${user.sportsID}/dashboard`;
	if (player.isLoading)
		return (
			<div id='fullHeight'>
				<div id='loading' />
			</div>
		);
	const { sportsName, sportsID } = user;
	const sportFromUrl = window.location.pathname.split('/')[1]?.toLowerCase();
	const isCFB = sportFromUrl === 'cfb' || Number(sportsID) === 5;

	if (!player || !player.data) return null;

	const playerInfo = player && player.data && player.data.playerInfo[0];
	const playerHistory = player.data && player.data.playerHistory;
	// CFB uses separate player/team news from the RSS endpoint; other sports use latestNews / AggregatedNews
	const latestNews = isCFB ? (cfbPlayerNews || []) : (player.data && player.data.latestNews);
	const news = isCFB ? null : (player.data && player.data.AggregatedNews);
	const cfbTeamNewsData = isCFB ? (cfbTeamNews || []) : [];
	const tweetInfo = player.data && player.data.tweetInfo;
	const nextGame = player.data && player.data.nextGame;
	console.log(playerHistory, playerInfo, 'playerHistory')
	// Determine if there is content for aggregated news or tweets
	const hasAggregated = Array.isArray(news) && news.length > 0;
	const hasTweets = tweetInfo && Array.isArray(tweetInfo.tweets) && tweetInfo.tweets.length > 0;
	const latestAsTwoColumn = !hasAggregated && !hasTweets;
	const healthStatus = playerInfo && playerInfo.health_score ? checkHealthScoreStatus(playerInfo.health_score, null, 'player') : '';
	const teamHealthStatus = playerInfo && playerInfo.team_health_score ? checkHealthScoreStatus(playerInfo.team_health_score, null, 'team') : '';
	const healthScoreDesc = `Health score represents the overall impact of a players' past injuries to give an overall performance ranking`;
	const teamHealthScoreDesc = `Team health score represents the overall impact of all starting players' health scores to give an overall performance ranking`;
	const showReturnDate = showHealthyToReturnDate(playerInfo?.recovery_return_date, 3);

	// Apply 3-month expiry logic to determine if player should be marked as fully recovered
	const isFullyRecovered = isPlayerFullyRecovered(playerInfo, sportsID);
	const playerHistoryForHeader = (player.data && player.data.playerHistory && player.data.playerHistory.length > 0 && player.data.playerHistory[0].body_part) || '';
	const lastInjuryLabel = (playerInfo && playerInfo.body_part && String(playerInfo.body_part).trim())
		? playerInfo.body_part
		: ((playerHistoryForHeader && playerHistoryForHeader.trim()) ? playerHistoryForHeader : getMappedBodyPartFromPlayer(playerInfo));
	// console.log("line no 89",playerHistoryForHeader);	
	// Function to get sport-specific icon based on sportId
	const getSportIcon = (sportId) => {
		switch (sportId) {
			case 1: // NFL
				return footballIcon;
			case 2: // NBA
				return basketballIcon;
			case 3: // Soccer
				return soccerIcon;
			default:
				return gameMissed; // fallback to original icon
		}
	};

	const getBoosterArrowClass = () => {
		const teamDate = playerInfo?.full_recovery_date_by_team ? new Date(playerInfo.full_recovery_date_by_team) : null;
		const algoDate = playerInfo?.recovery_return_date ? new Date(playerInfo.recovery_return_date) : null;
		if (!teamDate || !algoDate) return "boosterarrow";
		if (teamDate < algoDate) return "boosterarrow left";
		if (teamDate > algoDate) return "boosterarrow right";
		return "boosterarrow";
	};

	// Calculate difference in days between team and algo return dates
	// team_expected_return_date is the authoritative team date field; full_recovery_date_by_team is the fallback
	const teamDate = (playerInfo?.team_expected_return_date && String(playerInfo.team_expected_return_date).trim() !== '' && playerInfo.team_expected_return_date !== 'null')
		? new Date(playerInfo.team_expected_return_date)
		: (playerInfo?.full_recovery_date_by_team ? new Date(playerInfo.full_recovery_date_by_team) : null);
	// const teamDate = playerInfo?.full_recovery_date_by_team ? new Date(playerInfo.full_recovery_date_by_team) : null;
	const algoDate = playerInfo?.recovery_return_date ? new Date(playerInfo.recovery_return_date) : null;
	const now = new Date();

	// Treat null/empty injury_status as active — CFB players often have no designation set when healthy.
	// Only flag as injured if explicitly set to a known injured status.
	const INJURED_STATUSES = ['out', 'questionable', 'doubtful', 'probable', 'ir', 'inactive', 'injured', 'day-to-day', 'gtd', 'dnp', 'limited', 'lp'];
	const injuryStatusLower = (playerInfo?.injury_status || '').toLowerCase().trim();
	const isInjuryStatusActive = !injuryStatusLower || !INJURED_STATUSES.includes(injuryStatusLower);

	// When player is Active and no team date is set, use algo date as the effective team date
	// so the display shows the expected return instead of N/A/TBD until the date passes
	const isPlayerActive = isInjuryStatusActive;
	const effectiveTeamDate = teamDate || (isPlayerActive && algoDate ? algoDate : null);

	let differenceInDays = 0;

	// Check if both dates exist for FIBO meter activation.
	// Require algoDate > now so a stale past HPF date doesn't skew the comparison.
	const bothDatesExist = effectiveTeamDate && algoDate && algoDate > now;

	const isActivePlayer = isInjuryStatusActive;
	// showTBD is based only on team_expected_return_date (AI-sync field), NOT full_recovery_date_by_team
	// (HPF legacy field). full_recovery_date_by_team being set must not suppress TBD.
	const hasExplicitTeamDate = !!(playerInfo?.team_expected_return_date &&
		String(playerInfo.team_expected_return_date).trim() !== '' &&
		playerInfo.team_expected_return_date !== 'null');
	const showTBD = !isFullyRecovered && !hasExplicitTeamDate && !isInjuryStatusActive;


	if (bothDatesExist) {
		differenceInDays = Math.round((effectiveTeamDate - algoDate) / (1000 * 60 * 60 * 24));
	}
	// Use playerInfo.injury_grade or similar for grade if available
	const grade = playerHistory.length > 0 ? playerHistory[0].final_injury_grade : null;

	// Table mapping for grade and difference ranges
	// const gradeRanges = {
	// 	0.5: [-5, -4, -3, -2, 1, 2, 3, 4, 5],
	// 	1: [-10, -8, -6, -4, 2, 4, 6, 8, 10],
	// 	2: [-15, -12, -9, -6, 3, 6, 9, 12, 15],
	// 	3: [-25, -20, -15, -10, 5, 10, 15, 20, 25],
	// 	4: [-50, -40, -30, -20, 10, 20, 30, 40, 50],
	// 	5: [-105, -90, -60, -45, 30, 45, 60, 90, 105],
	// };
	const gradeRanges = {
		"0.5": [5, 4, 3, 2, -1, -2, -3, -4, -5],
		"1": [10, 8, 6, 4, -2, -4, -6, -8, -10],
		"2": [15, 12, 9, 6, -3, -6, -9, -12, -15],
		"3": [25, 20, 15, 10, -5, -10, -15, -20, -25],
		"4": [50, 40, 30, 20, -10, -20, -30, -40, -50],
		"5": [105, 90, 60, 45, -30, -45, -60, -90, -105]
	}


	function getArrowPositionIndex(grade, diff) {
		if (isFullyRecovered || diff === 0) {
			return 5
		}
		// If difference is extreme, force to end
		if (Math.abs(diff) >= 182) return diff < 0 ? 10 : 0;

		// Use closest grade if not exact
		let g = parseFloat(grade);
		console.log(g, 'g')
		if (!gradeRanges[g]) {
			// fallback to closest
			g = Object.keys(gradeRanges).map(Number).reduce((prev, curr) =>
				Math.abs(curr - g) < Math.abs(prev - g) ? curr : prev
			);
		}
		const ranges = gradeRanges[g];
		console.log(ranges, 'ranges11', isFullyRecovered)
		// check if full recorry 


		// Center range (Truth) is always the middle (index 4)
		// if (Math.abs(diff) <= Math.abs(ranges[4])) return 4;

		// // Left side (Recovery Shorter than Team's - Point to LIE)
		// // Negative diff means shorter recovery, should point left (LIE)
		// if (diff < 0) {
		// 	for (let i = 3; i >= 0; i--) {
		// 		if (diff <= ranges[i]) return i;
		// 	}
		// }

		// // Right side (Recovery Longer than Team's - Point to RECKLESS)
		// // Positive diff means longer recovery, should point right (RECKLESS)
		// if (diff > 0) {
		// 	for (let i = 5; i <= 8; i++) {
		// 		if (diff <= ranges[i]) return i;
		// 	}
		// }
		// Reckless side (Team sooner than algo → diff < 0 → right side)
		if (Math.abs(diff) <= Math.abs(ranges[4])) {
			return 5; // always the middle index
		}
		if (diff < 0) {
			// Reckless: arrow left side (0 to 3)
		
			for (let i = 5; i <= 8; i++) {
				console.log(ranges[i],diff,'ranges[i]')
				if (diff >= ranges[i]) return i;
			}
			return 10;
		}

		if (diff > 0) {
			// Lie: arrow right side (5 to 8)
			for (let i = 0; i <= 3; i++) {
				console.log(i, 'ranges[i]',ranges[i],diff)
				if (diff >= ranges[i]) return i;

			}
			return 0;
		}


		console.log(diff, 'diff')
		// If more extreme, clamp to 0 (LIE) or 10 (RECKLESS)
		return diff < 0 ? 10 : 0;
	}
	
	// Only calculate arrow position if both dates exist
	const arrowPosIndex = bothDatesExist ? getArrowPositionIndex(grade, differenceInDays) : 4; // Default to center if not enough data
	const arrowClass = bothDatesExist ? `boosterarrow pos-${arrowPosIndex}` : 'boosterarrow';

	return !playerInfo ? (
		<div className='playerMainDiv'>
			<UserHeader matchup={true} player={true} backgroundColor={'#f7f7f7'} title={title} />
			<h1 style={{ textAlign: 'center' }}>No info found for player</h1>
		</div>
	) : (
		<section className='playerMainSection'>
			<div className='playerMainDiv'>
				<UserHeader matchup={true} player={true} backgroundColor={'#f7f7f7'} returnFunction={() => togglePlayerView()} />
				{/* <div className="playerInfoMobileTeamLogoDiv">
                <img
                  src={playerInfo.team_logo}
                  alt="Team Logo"
                  className="playerInfoMobileTeamLogo"
                />
              </div> */}
				<div className="playerInfoRow">
					<div className='container'>
						<div className="d-flex align-items-center profile_hdr justify-content-center">
							<figure className="player_logo 465 text-center mb-0 me-3">
								{isCFB && playerInfo.ap_rank ? (
									<figcaption className="by_week cfb-ap-rank">CURRENT AP RANK: #{playerInfo.ap_rank}</figcaption>
								) : null}
								<img src={playerInfo.team_logo !== 'null' ? playerInfo.team_logo : playerInfo.team_logo_secondary} alt={`${playerInfo.player_name}`} wdth="" className='playerInfoImg' />
							</figure>
							{/* <div className="d-flex align-items-center player_name">
							<h2 className="h3 mb-0">{playerInfo.jersey} {playerInfo.nickname || playerInfo.player_name} ({playerInfo.position})</h2>
							{(playerInfo.injury_status === "Out" || playerInfo.injury_status === "Probable" || playerInfo.injury_status === "Questionable") && <span className="badge bg-danger ms-4">Injured</span>}
						</div> */}
							<div className="d-flex align-items-center player_name">
								<h2 className="h3 mb-0">{playerInfo.jersey} {playerInfo.nickname || playerInfo.player_name} ({playerInfo.position})</h2>
								{!isFullyRecovered && !isInjuryStatusActive && (
									(playerInfo?.recovery_return_date && new Date(playerInfo.recovery_return_date) > new Date()) ||
									(playerInfo?.injury_status && playerInfo.injury_status !== 'Active' && playerInfo.injury_status !== 'active')
								) && (
									<span className="badge bg-danger ms-4">Injured</span>
								)}
							</div>
						</div>


						<div className='playerInfoDiv'>

							<div className={`d-flex flex-wrap align-items-center playerInfoStatsDiv${isCFB ? ' cfb-stats-row' : ' justify-content-center'}`}>
								{isCFB ? (
									<>
										{(playerInfo.height || playerInfo.weight) && (
											<span className='playerInfoStatsTitle'>
												<strong>HT/WT: {calculateHeight(playerInfo.height)}{playerInfo.weight ? `, ${playerInfo.weight} lbs` : ''}</strong>
											</span>
										)}
										{playerInfo.class && (
											<span className='playerInfoStatsTitle'>
												<strong>Class:</strong> {playerInfo.class}
											</span>
										)}
										<span className='playerInfoStatsTitle'>
											<strong>Last Injury:</strong>{' '}
											{(playerInfo.injury_body_part && playerInfo.injury_body_part !== 'null' && playerInfo.injury_body_part.trim() !== '')
												? playerInfo.injury_body_part
												: 'None'}
										</span>
										{nextGame && (
											<span className='playerInfoStatsTitle'>
												<strong>Next Game:</strong>{' '}
												{new Date(nextGame.date_time).toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' })}
												{' '}
												{parseInt(nextGame.away_team_id) === parseInt(playerInfo.team_id)
													? `@ ${nextGame.home_team_city} ${nextGame.home_team_name}`.trim()
													: `vs ${nextGame.away_team_city} ${nextGame.away_team_name}`.trim()}
											</span>
										)}
										<div className='cfb-quick-links-block'>
											<span className='cfb-quick-links-label'>
												<strong>{[playerInfo.team_city, playerInfo.team_name].filter(Boolean).join(' ')} Quick Links:</strong>
											</span>
											<div className='cfb-quick-links-buttons'>
												<a href={`/cfb/team/${playerInfo.team_id}`} className="cfb-quick-link">
													<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
													{' '}Schedule
												</a>
												<a href={`/cfb/team/${playerInfo.team_id}?tab=roster`} className="cfb-quick-link">
													<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>
													{' '}Roster
												</a>
											</div>
										</div>
									</>
								) : (
									<>
										<span className='playerInfoStatsTitle'><strong>HEIGHT: {calculateHeight(playerInfo.height)}</strong></span>
										<span className='playerInfoStatsTitle'><strong>WEIGHT: {playerInfo.weight}</strong></span>
										<span className='playerInfoStats'>
											<span className='playerInfoStatsTitle'><strong>AGE: {playerInfo.age}</strong></span>
										</span>
										{playerInfo.status && (
											<span className='playerInfoStatsTitle'>
												<strong>Last Injury</strong>: {lastInjuryLabel}
											</span>
										)}
									</>
								)}
							</div>

							{/* <FiboMeter
							algoReturnDate={playerInfo.recovery_return_date || null}
							teamReturnDate={playerInfo.team_expected_return_date || null}
							actualReturnDate={playerInfo.actual_return_date || null}
						/> */}
						</div>

						<div className="player-main">
							<div className="player-left">
								{/* Listing */}
								{
									// (playerInfo.injury_status === "Out" || playerInfo.injury_status === "Probable" || playerInfo.injury_status === "Questionable") &&
									<ul className="list-unstyled current_status w-100 text-start mt-3">
										<li>
											<em className="me-2"><img src={currentStatus} width="32" alt='' /></em>
											{/* Current Status: {isFullyRecovered ? 'Fully Recovered' : (playerHistory?.length > 0 && playerHistory[0]?.grid_status ? getStatusFromGridStatus(playerHistory[0].grid_status) : 'N/A')} */}
											Current Status: {(() => {
													if (isFullyRecovered) return 'Fully Recovered';
													const injuryStatus = playerInfo?.injury_status;
													const INACTIVE = ['active', 'null', '', null, undefined];
													// 1. injury_status set correctly (non-Active)
													if (injuryStatus && !INACTIVE.includes(injuryStatus.toLowerCase())) return injuryStatus;
													// 2. ai_status on most recent injury row (set by AI sync, never overwritten by crawler)
													const aiStatus = playerHistory?.length > 0 ? playerHistory[0]?.ai_status : null;
													if (aiStatus && !INACTIVE.includes(aiStatus.toLowerCase())) return aiStatus;
													// 3. grid_status from practice reports
													if (playerHistory?.length > 0 && playerHistory[0]?.grid_status) return getStatusFromGridStatus(playerHistory[0].grid_status) || 'Active';
													return 'Active';
												})()}
										</li> 
										<li>
											<em className="me-2"><img src={expectedReturn} width="32" alt='' /></em>
											Estimated Full Recovery By Inside Injuries: {(() => {
												if (isFullyRecovered && (!algoDate || algoDate <= now)) return 'N/A (Fully Recovered)';
												// Active player — injury cleared, HPF date is stale
												if (isInjuryStatusActive) return 'N/A';
												const dateOpts = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
												// HPF date is in the future — show it
												if (algoDate && algoDate > now) return algoDate.toLocaleDateString('en-US', dateOpts);
												// HPF date is past — fall back to team_expected_return_date if future.
												// Only when algoDate existed but is stale; if no HPF row (e.g. CFB), skip fallback.
												const teamRetStr = playerInfo?.team_expected_return_date;
												if (algoDate && !isFullyRecovered && teamRetStr && String(teamRetStr).trim() !== '' && teamRetStr !== 'null') {
													const teamD = new Date(teamRetStr);
													if (teamD > now) return teamD.toLocaleDateString('en-US', dateOpts);
												}
												// HPF date has passed without the player returning — show last projected date with overdue note
												if (algoDate) return algoDate.toLocaleDateString('en-US', dateOpts);
												// CFB: no HPF data — use AI-estimated team_expected_return_date as best available
												if (isCFB && teamRetStr && String(teamRetStr).trim() !== '' && teamRetStr !== 'null') {
													const d = new Date(teamRetStr);
													if (d > now) return d.toLocaleDateString('en-US', dateOpts);
												}
												return 'N/A';
											})()}
										</li>
										<li>
											<em className="me-2"><img src={fullRecovery} width="32" alt='' /></em>
											Current Expected Return By Team: {
												(() => {
													const dateOpts = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
													// 1. Explicit team_expected_return_date set — show it unless past and fully recovered
													if (playerInfo?.team_expected_return_date && String(playerInfo.team_expected_return_date).trim() !== '' && playerInfo.team_expected_return_date !== 'null') {
														const d = new Date(playerInfo.team_expected_return_date);
														if (isFullyRecovered && d <= now) return 'N/A (Fully Recovered)';
														return d.toLocaleDateString('en-US', dateOpts);
													}
													// 2. Legacy full_recovery_date_by_team field
													if (showHealthyToReturnDate(playerInfo?.recovery_return_date, 3) && playerInfo?.full_recovery_date_by_team) {
														const d = new Date(playerInfo.full_recovery_date_by_team);
														if (isFullyRecovered && d <= now) return 'N/A (Fully Recovered)';
														return d.toLocaleDateString('en-US', dateOpts);
													}
													// 3. Player Active or no injury data → no pending return date to show
													const hasNoInjuryData = !playerInfo?.injury_date && !playerInfo?.recovery_return_date;
													if (isPlayerActive || hasNoInjuryData) {
														return 'N/A';
													}
													// 4. Show TBD when injured player has no team return date
													if (showTBD) return 'TBD';
													// 5. All dates expired → fully recovered
													if (isFullyRecovered) return 'N/A (Fully Recovered)';
													return 'N/A';
												})()
											}
										</li>
										<li>
											<em className="me-2"><img src={getSportIcon(sportsID)} width="32" alt='' /></em>
											Games Missed This Season: {playerInfo?.gameMissed || 'N/A'}
										</li>
									</ul>
								}

								{/* Progressbar */}
								<div className="w-100 text-center mt-3 playerInfoProgressDiv">
									<h6 className='playerInfoProgressLabel'>
										Player Health Score: {" "}
										<span className={`playerInfoProgressValue ${healthStatus.color}`}>{healthStatus.status}</span>
									</h6>
									<div className="d-flex flex-wrap flex-md-nowrap justify-content-center playerInfoProgressBarDiv">
										<div className="w-100 progressbar_elem displayTableCell">
											{/* <Line
												percent={Math.min(playerInfo.health_score ?? 100, 100)}
												strokeWidth="4"
												trailWidth="4"
												trailColor="rgba(21, 21, 21, .06)"
												strokeColor={highlightColumnColor(playerInfo.health_score, 'cardSpread', 'playerhealth', true)}
											/> */}
											<div
												className="progressbar_div"
												role="progressbar"
												aria-valuemin={0}
												aria-valuemax={100}
												aria-valuenow={Math.min(playerInfo.health_score ?? 100, 100)}
												aria-label="Player Health Score"
											>
												<div className="progressbar_div_track">
													<div
														className="progressbar_div_fill"
														style={{
															width: `${Math.min(playerInfo.health_score ?? 100, 100)}%`,
															backgroundColor: highlightColumnColor(playerInfo.health_score, 'cardSpread', 'playerhealth', true)
														}}
													/>
												</div> 
											</div>
										</div>
										<div className="d-flex align-items-center mx-3 progress_value">
											<span className='playerInfoProgressBarValue displayTableCell'><strong>{playerInfo.health_score ? `${playerInfo.health_score}/100` : `100/100`}</strong></span>
											<span className="d-inline-flex justify-content-center align-items-center info_icon">
												<DashboardTip title='PLAYER HEALTH SCORE' description={healthScoreDesc} component={'player_health_score'} />
											</span>
										</div>
									</div>
								</div>

								<div className="w-100 text-center mt-3 playerInfoProgressDiv">
									<h6 className='playerInfoProgressLabel'>
										Team Health Score: {" "}
										<span className={`playerInfoProgressValue ${teamHealthStatus.color}`}>{teamHealthStatus.status}</span>
									</h6>
									<div className="d-flex flex-wrap flex-md-nowrap justify-content-center playerInfoProgressBarDiv">
										<div className="w-100 progressbar_elem displayTableCell">
											<Line percent={(playerInfo.team_health_score / 10) * 100} strokeWidth='4' trailWidth='4' trailColor='rgba(21, 21, 21, .06)' strokeColor={highlightColumnColor(playerInfo.team_health_score, 'cardSpread', 'teamhealth', true)} />
										</div>
										<div className="d-flex align-items-center mx-3 progress_value">
											<span className='playerInfoProgressBarValue displayTableCell'><strong>{playerInfo.team_health_score}/10</strong></span>
											<span className="d-inline-flex justify-content-center align-items-center info_icon">
												<DashboardTip title='TEAM HEALTH SCORE' description={teamHealthScoreDesc} component={'team_health_score'} />
											</span>
										</div>
									</div>
								</div>

								<Row className='playerTotalInjuryRow container-fluid'>
									<Col lg={6} className='playerTotalInjuryCol'>
										<div className='playerTotalInjuryDiv'>
											<p className='playerTotalInjury'><strong>TOTAL INJURIES LAST 12 MONTHS:</strong></p>
											<p className='playerTotalInjuryValue'>
												{playerInfo?.total_1_year_injuries_count ?? playerHistory?.length}
											</p>
										</div>
									</Col>
									<Col lg={6} className='playerTotalInjuryCol'>
										<div className='playerTotalInjuryDiv'>
											<p className='playerTotalInjury'><strong>TOTAL INJURIES LAST 3 YEARS:</strong></p>
											<p className='playerTotalInjuryValue'>{playerInfo.total_3_year_injuries_count || 0}</p>
										</div>
									</Col>
								</Row>
								<div className='playerHistoryDiv'>
									<p className='playerTotalInjuryHistory'>TOTAL INJURIES LAST 12 MONTHS:</p>
									{playerHistory &&
										playerHistory.map((history, i) => (
											<Row key={i} className='playerHistoryRow'>
												<Col lg={4} className='playerHistoryCol'>
													<p className='playerHistoryLabel'>INJURY</p>
													<p className='playerHistoryValue'>{history.ai_body_part || history.body_part}</p>
												</Col>
												{/* <Col lg={5} className="playerHistoryCol">
													<p className="playerHistoryLabel">DESCRIPTION</p>
													<p className="playerHistoryValue">
													{history.admin_injury_grade || history.final_injury_grade}
													</p>
												</Col> */}
												<Col lg={4} className='playerHistoryCol'>
													<p className='playerHistoryLabel'>INJURY GRADE</p>
													<p className='playerHistoryValue'>{history.admin_injury_grade || history.final_injury_grade}</p>
												</Col>
												<Col lg={4} className='playerHistoryCol'>
													<p className='playerHistoryLabel'>DATE</p>
													<p className='playerHistoryValue'>{history.ai_injury_date ? formatDate(true, history.ai_injury_date) : (history.injury_date ? formatDate(true, history.injury_date) : 'No Recent Injury')}</p>
												</Col>
											</Row>
										))}
								</div>
							</div>
							<div className="player-right">
								<h3>FIB-O-Meter</h3>
								<div className="booster">
									<img src={booster} width="400" alt='booster' />
									{!showTBD && <img className={arrowClass} src={boosterarrow} height="170" alt='boosterarrow' />}
								</div>
								<p>This meter compares our algorithm's predicted healthy return date with the team's reported return date.</p>
								<p>It helps identify whether a team may be:</p>
								<ul>
									<li>Accurate - Aligning with data</li>
									<li>Overcautious - Delaying a return unnecessarily</li>
									<li>Risky or Misleading - Rushing a return or providing inaccurate timelines</li>
								</ul>
							</div>
						</div>


						{playerInfo?.injury_comment && String(playerInfo.injury_comment).trim() !== '' && (
							<div className="ai-injury-comment-box">
								<strong>AI Injury Analysis:</strong>
								<p>{playerInfo.injury_comment}</p>
							</div>
						)}

						<div className="news-container">
							{/* <PlayerNews /> */}
							{isCFB ? (
								<>
									{/* Left: team news from player_news (sport_id=5, TeamID match) */}
									<LatestNews news={cfbTeamNewsData} twoColumn={false} label="Team News" />
									{/* Right: player-specific news from player_news (sport_id=5, PlayerID match) */}
									<LatestNews news={latestNews || []} twoColumn={false} label="Player News" />
								</>
							) : (
								<>
									{/* Left slot: Aggregated if present, otherwise Latest */}
									{hasAggregated ? (
										<AggregatedNews news={news} />
									) : (
										<LatestNews news={latestNews || []} twoColumn={latestAsTwoColumn} />
									)}

									{/* Right slot: Twitter if present, else Latest only when Aggregated exists */}
									{hasTweets ? (
										<TwitterFeed
											tweets={tweetInfo?.tweets}
											twitter_handle={tweetInfo?.twitter_handle}
											twitter_profile_image={tweetInfo?.twitter_profile_image}
										/>
									) : (
										hasAggregated && <LatestNews news={latestNews || []} twoColumn={false} />
									)}
								</>
							)}
						</div>


					</div>
				</div>
			</div>
		</section>
	);
}

const mapStateToProps = (state) => ({
	isLoading: state.isLoading,
	isLoaded: state.isLoaded,
	match: state.match,
	player: state.player,
	playerHistory: state.playerHistory,
	AggregatedNews: state.AggregatedNews,
	cfbPlayerNews: state.cfb?.playerNews || [],
	cfbTeamNews: state.cfb?.teamNews || [],
	user: state.user
});

export default connect(mapStateToProps)(Player);

